import scroll from "scroll"
import scrollDoc from "scroll-doc"

const scrollToTop = () => {
  const page = scrollDoc()
  scroll.top(page, 0)
}

export default scrollToTop
